<footer class="vitrine-footer">
  <div class="footer-container">

    <div class="footer-grid">

      <!-- Brand -->
      <div class="footer-brand">
        <div class="footer-logo-wrap">
          <img src="assets/layout/images/logo-sgmao.jpg" alt="SGMAO" loading="lazy">
          <span class="footer-logo-text">SGMAO</span>
        </div>
        <p class="footer-brand-desc">
          Solution de gestion de maintenance nouvelle génération pour l'industrie 4.0.
          Optimisez vos opérations, réduisez vos coûts et garantissez la disponibilité de vos équipements.
        </p>
        <div class="footer-social">
          <a class="social-icon" aria-label="LinkedIn" href="#"><i class="pi pi-linkedin"></i></a>
          <a class="social-icon" aria-label="Email" (click)="goToContact()"><i class="pi pi-envelope"></i></a>
        </div>
        <div class="footer-contact-list">
          <a href="tel:+22654916757" class="footer-contact-item">
            <i class="pi pi-phone"></i> +226 54 91 67 57
          </a>
          <a href="tel:+22670072352" class="footer-contact-item">
            <i class="pi pi-phone"></i> +226 70 07 23 52
          </a>
          <a href="mailto:contact@sgmao.com" class="footer-contact-item">
            <i class="pi pi-envelope"></i> contact&#64;sgmao.com
          </a>
          <span class="footer-contact-item">
            <i class="pi pi-map-marker"></i> Somgandé, Ouagadougou — Burkina Faso
          </span>
        </div>
      </div>

      <!-- Solutions -->
      <div class="footer-col">
        <h4>Solutions par secteur</h4>
        <a routerLink="/public/solutions/hopital">Hôpitaux & Santé</a>
        <a routerLink="/public/solutions/industrie">Industries & Usines</a>
        <a routerLink="/public/solutions/collectivite">Collectivités & Mairies</a>
      </div>

      <!-- Pour qui -->
      <div class="footer-col">
        <h4>Pour qui ?</h4>
        <a routerLink="/public/roles/technicien">Technicien / Agent</a>
        <a routerLink="/public/roles/gestionnaire">Gestionnaire</a>
        <a routerLink="/public/roles/daf">DAF</a>
      </div>

      <!-- Produit -->
      <div class="footer-col">
        <h4>Produit</h4>
        <a routerLink="/" fragment="features">Fonctionnalités</a>
        <a routerLink="/" fragment="workflow">Comment ça marche</a>
        <a routerLink="/" fragment="gestion-roles">Gestion des rôles</a>
        <a routerLink="/" fragment="pricing">Tarifs</a>
        <a routerLink="/" fragment="faq">FAQ</a>
      </div>

      <!-- Entreprise + CTA -->
      <div class="footer-col">
        <h4>Entreprise</h4>
        <a routerLink="/public/apropos">À propos</a>
        <a routerLink="/public/carrieres">Carrières</a>
        <a (click)="goToContact()">Contact</a>

        <div class="footer-cta-box">
          <p>Prêt à démarrer ?</p>
          <button class="footer-cta-btn" (click)="goToRegister()">
            Essai gratuit <i class="pi pi-arrow-right"></i>
          </button>
        </div>
      </div>

    </div>

    <!-- Bottom bar -->
    <div class="footer-bottom">
      <span class="copyright">© {{ currentYear }} SGMAO. Tous droits réservés.</span>
      <span class="powered">Propulsé par <strong>Neerelab Technologies</strong></span>
      <div class="legal-links">
        <a routerLink="/public/mentions-legales">Mentions légales</a>
        <a>Politique de confidentialité</a>
        <a>Conditions d'utilisation</a>
        <span>Hébergé en Europe</span>
      </div>
    </div>

  </div>
</footer>
